import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    this.element.addEventListener("turbo:submit-end", this.handleResponse.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.handleResponse.bind(this))
  }

  handleResponse(event: CustomEvent) {
    const response = event.detail?.fetchResponse?.response

    console.log('Headers recebidos:', response.headers)

    if (response?.ok) {
      const redirectUrl = response.headers.get("Turbo-Location")
      if (redirectUrl) {
        event.preventDefault()
        window.location.href = redirectUrl
      }
    }
  }
}
